import HTTP from '@pillarjs/http';
import { Notification, MessageBox } from "@unicloud/element-ui";

const httpInstance = new HTTP({
  baseURL: "/api",  //需要本地做反向代理
  timeout: 60000,   //设置超时时间
  responseType: "json",
  withCredentials: true,  //是否允许带cookie
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  globalError: error => {
    // 统一请求错误处理
    console.dir(error)

    let msg = (error.response.data && Object.prototype.toString.call(error.response.data) === '[object Object]' && error.response.data.msg) ? error.response.data.msg : '';
    switch (Number(error.response.status)) {
      case 401:
        MessageBox({
          title: '提示',
          confirmButtonText: '关闭',
          message: '您没有服务权限，请联系主账号前往 IAM 控制台授权',
        });
        break;

      case 403:
        Notification({
          title: '错误',
          message: msg || "访问被禁止，请联系管理员",
          type: "error"
        });
        break;

      case 404:
        Notification({
          title: '错误',
          message: msg || "资源不存在，请联系管理员",
          type: "error"
        });
        break;

      case 500:
        Notification({
          title: '错误',
          message: msg || "网络异常，请稍后重试",
          type: "error"
        });
        break;

      default:
        break;
    }
    return Promise.reject(error);
  }
});

//请求拦截器
httpInstance.useRequestInterceptor(
  config => {
    config.params = config.params ? config.params : {};
    if (config.method === "get" && config.params) {
      //消除ie对get请求默认取缓存的影响
      config.params.t = new Date().getTime();
    }

    //匹配微服务请求，添加对应前缀
    let url = config.url;
    let replaceUrl = GLOBAL.msBaseUrl.filter(item => url.indexOf(item.matchedUrl) > -1);

    if (replaceUrl.length > 0) {
      config.url = url.replace(replaceUrl[0].matchedUrl, replaceUrl[0].msPrefix + replaceUrl[0].matchedUrl);
    }

    //有鉴权信息时需带上token
    if (typeof (localStorage) !== 'undefined' && localStorage.getItem("token") && config.url.indexOf("login") <= -1) {
      config.headers['x-auth-token'] = localStorage.getItem("token");
    }

    return config;
  },
);

//响应拦截器
httpInstance.useResponseInterceptor(
  res => {
    let userInfo = JSON.parse(localStorage.getItem('user'));
    let CURL = window.location.href;

    // 发现没有权限跳至登录页面
    if (!res.data.auth || !localStorage.getItem('token')) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (userInfo.type == 'PUBLIC') {
        window.location.href = "/login?url=" + CURL;
      } else if (userInfo.type == 'CHILD') {
        window.location.href = "/iam/login?url=" + CURL;
      }
    }


    // if (Number(res.data.code) !== 0) {
    //   Notification({
    //     title: '失败',
    //     message: res.data.msg || "未知错误",
    //     type: "error"
    //   });
    // }

    return res;
  }
);

const install = (Vue) => {
  Object.defineProperty(Vue.prototype, "$http", { value: httpInstance });
}

export const http = httpInstance;

//将axios的实例重新封装成一个plugin，方便 Vue.use(XXX)
export default install;
